import styles from './NameInput.module.css'
import { useEffect, useRef } from 'react';

export default function NameInput({name = "", setName = (value) => {}, label = "Имя", id = "name", placeholder = "Имя", auto_focus = false, error_message = "", reset_error_callback = () => {}})
{
    //Ссылка на поле ввода
    const textInput = useRef(null);

    const inputHandler = (e) => {
        //Формируем callback для сохранения позиции каретки в случае, если данные не изменились несмотря на ввод пользователя
        const caretStart = e.target.selectionStart;
        const caretEnd = e.target.selectionEnd;
        const save_caret_callback = () => {e.target.setSelectionRange(caretStart, caretEnd)};

        //Проверяем полученные данные на длину и некорректные символы
        if(e.target.value.length > 45)
        {
            //Отрабатываем callback и выходим
            save_caret_callback();
            return;
        }

        //Обновляем состояние
        setName(e.target.value);
        //Сбрасываем ошибку
        reset_error_callback();
    }

    //Автофокус при появлении компонента, если нужно
    useEffect(() => {
        if(auto_focus && textInput !== null)
            textInput.current.focus();
    }, []);

    return (
        <div className={styles.formGroup} onClick={(e) => { if(textInput !== null) textInput.current.focus() }}>
            <input id={id} name={id} className={error_message.length ? [styles.formInput, styles.error].join(' ') : styles.formInput} type="text" placeholder={placeholder} value={ name }
                   onChange={ inputHandler } ref={textInput}></input>
            <label htmlFor={id} className={styles.formLabel}>{label}</label>
            <span className={styles.formClear} onClick={(e) => { setName(""); reset_error_callback(); }}>
                <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 10.0914L10 1.09137M1 1L10 9.99999" stroke="#7E7E7E" strokeWidth="0.909137" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </span>
            {error_message.length !== 0 &&
            <div className={styles.formError}>{error_message}</div>
            }
        </div>
    );
}
